import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.ResourceFilters;
const filterDisplay = CONST.globalProject.ResourceFilterDisplay;

// initial state
// object name must match specification name
// specification, label, defaultValue, collapsible, expandDefault, groupType, subgroup, className
const filters = {
    Sort: new FormControl.FilterGroup('Sort', 'Sort By', 'Newest', false, true, 'select'),
    searchTerm: new FormControl.FilterGroup(
        'SearchTerm', 'Filter By Keyword', '', false, true, 'textbox',
        new FormControl.Textbox('Type to search', 'SearchTerm', true), 'filter-search'
    ),
    Topic: new FormControl.FilterGroup('Topic', 'Filter by Topic', null, false, true, 'checkbox', undefined, 'filter-flex', filterDisplay.hideTopic),
    Type: new FormControl.FilterGroup('Type', 'Filter by Type', null, false, true, 'checkbox', undefined, 'filter-flex filter-buttons-equal', filterDisplay.hideType),
    Language: new FormControl.FilterGroup('Language', 'Filter by Language', null, false, true, 'language', undefined, 'filter-flex filter-buttons-equal', filterDisplay.hideLanguage),
};

FormControl.assignFilters(filterObj, filters);

filters.Topic.subgroup.unshift(new FormControl.SelectOption('999', 'All Topics', true, false, false));
filters.Type.subgroup.unshift(new FormControl.SelectOption('999', 'All Types', true, false, false));
filters.Language.subgroup.unshift(new FormControl.SelectOption('English', 'English', true, false, false));

export { filters as default };